import React from 'react';
import Areas from '../pages/Areas/Areas';
import Calculator from '../pages/Calculator/Calculator';
import Menu from '../pages/Menu/Menu';
import Profile from '../pages/Profile/Profile';
import Team from '../pages/Team/Team';
import Wallet from '../pages/Wallet/Wallet';
import Bonus from '../pages/Bonus/Bonus';
import ContarctPage from '../pages/Contract/ContarctPage';
import ContractBonuses from '../pages/ContractBonuses/ContractBonuses';
import ContractAddDepositPage from '../pages/ContractAddDeposit/ContractAddDepositPage';
import { matchPath } from 'react-router';
import { Market } from '../pages/Market';
import CardFromMarket from '../pages/CardFromMarket/CardFromMarket';
import BuyCard from '../pages/BuyCard/BayCard';
import Review from '../pages/Review/Review';
import CreateCard from '../pages/CreateCard/CreateCard';

export interface IRouter {
    path: string;
    element: React.ComponentType;
}

export function removeNavFoot() {
    return (
        !matchPath('/menu', location.pathname) &&
        !matchPath('/contract/*', location.pathname) &&
        !matchPath('/market', location.pathname) &&
        !matchPath('/card/*', location.pathname) &&
        !matchPath('/buy-card/*', location.pathname) &&
        !matchPath('/review/*', location.pathname) &&
        !matchPath('/create/*', location.pathname) &&
        !matchPath('/edit/*', location.pathname)
    );
}

export enum RoutName {
    HOME = '/',
    WALLET = '/wallet',
    TEAM = '/team',
    MENU = '/menu',
    PROFILE = '/profile',
    CALCULATOR = '/calculator',
    AREAS = '/areas',
    BONUS = '/bonus',
    CONTRACT = '/contract',
    CONTRACT_BONUSES = '/contract/bonuses',
    CONTRACT_NEW_DEPOSIT = '/contract/new',
    MARKET = '/market',
    MARKET_CARD = '/card/:cardId',
    BUY_CARD = '/buy-card/:cardId',
    REVIEW_CARD = '/review/:cardId',
    CREATE_CARD = '/create',
    EDIT_CARD = '/edit/:cardId',
}

export const publicRoutes: IRouter[] = [
    { path: RoutName.HOME, element: Profile },
    { path: RoutName.WALLET, element: Wallet },
    { path: RoutName.TEAM, element: Team },
    { path: RoutName.MENU, element: Menu },
    { path: RoutName.PROFILE, element: Profile },
    { path: RoutName.BONUS, element: Bonus },
    { path: RoutName.AREAS, element: Areas },
    { path: RoutName.CALCULATOR, element: Calculator },
    { path: RoutName.CONTRACT, element: ContarctPage },
    { path: RoutName.CONTRACT_BONUSES, element: ContractBonuses },
    { path: RoutName.CONTRACT_NEW_DEPOSIT, element: ContractAddDepositPage },
    { path: RoutName.MARKET, element: Market },
    { path: RoutName.MARKET_CARD, element: CardFromMarket },
    { path: RoutName.BUY_CARD, element: BuyCard },
    { path: RoutName.REVIEW_CARD, element: Review },
    { path: RoutName.CREATE_CARD, element: CreateCard },
    { path: RoutName.EDIT_CARD, element: CreateCard },
];
